import { render, staticRenderFns } from "./file-chips-field.vue?vue&type=template&id=9dee8656&scoped=true&"
import script from "./file-chips-field.vue?vue&type=script&lang=js&"
export * from "./file-chips-field.vue?vue&type=script&lang=js&"
import style0 from "./file-chips-field.vue?vue&type=style&index=0&id=9dee8656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dee8656",
  null
  
)

export default component.exports